import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { BannerService } from '../../services/banner.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'banner-locale',
    templateUrl: './banner-locale.component.html',
    styleUrls: ['./banner-locale.component.scss']
})
export class BannerLocaleComponent implements OnInit, OnDestroy {

    @Input()
    banner: any;

    @Input()
    formGroup!: FormGroup;

    @Output('refreshBanners')
    refreshEventEmitter = new EventEmitter<void>();

    deleteBannerLocaleVisible!: boolean;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private bannerService: BannerService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    displayDeleteBannerLocale() {
        this.deleteBannerLocaleVisible = true;
        setTimeout(() => this.deleteBannerLocaleVisible = false, 3000);
    }

    deleteBannerLocale() {
        this.progressIndicatorService.progress = true;
        this.bannerService.deleteBannerLocale(this.banner.id, this.formGroup.value.bannerLocaleLocaleInput).subscribe({
            next: (value: any) => {
                console.log('BannerLocaleComponent.deleteBannerLocale.bannerService.deleteBannerLocale.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('BannerLocaleComponent.deleteBannerLocale.bannerService.deleteBannerLocale.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    emitRefreshEvent() {
        this.refreshEventEmitter.emit();
    }
}
